import React, {
  useEffect,
  useState
} from 'react'
import {
  Popup,
  Responsive
} from 'semantic-ui-react'
import reduce from 'lodash/reduce'
// Local
import {
  API_URL,
  MOBILE_WIDTH,
  REVIEW,
  TABLET_WIDTH
} from '../../constant'
import { api } from '../../action/api'
import { ObjectValues } from '../../types/types'

type DashboardDailyReviewCountRow = {
  modificationDay: string
  reviewCode: string
  reviewCount: number
  reviewerUsername: string
  reviewerName: string
}

/**
 * Provides a component that displays the CDI user review count for the current
 * day. Count includes reviews marked READY_FOR_CDI_QA and READY_FOR_PHYSICIAN
 * Requires no properties.
 */
function CdiCounter(

): JSX.Element {
  const [
    reviewCountState,
    setReviewCountState
  ] = useState<number>(0)
  const [
    readyForCdiQaState,
    setReadyForCdiQaState
  ] = useState<number>(0)
  const [
    readyForPhysicianState,
    setReadyForPhysicianState
  ] = useState<number>(0)

  const reduceReviewCounts = (
    reviewCounts: DashboardDailyReviewCountRow[],
    reviewCode: ObjectValues<typeof REVIEW.CODE>
  ) => reduce(reviewCounts, (result, row) => {
    if (row.reviewCode === reviewCode) {
      return result + row.reviewCount
    }
    return result
  }, 0)

  useEffect(() => {
    let isMounted = true
    const fetchReviewCount = () => {
      const url = API_URL.REVIEW_COUNT
      api.get(url).then(({ data }) => {
        if (!isMounted) return
        const cdiQaCount = reduceReviewCounts(
          data as DashboardDailyReviewCountRow[],
          REVIEW.CODE.READY_FOR_CDI_QA
        )
        const physicianCount = reduceReviewCounts(
          data as DashboardDailyReviewCountRow[],
          REVIEW.CODE.READY_FOR_PHYSICIAN
        )
        const total = cdiQaCount + physicianCount
        setReviewCountState(total)
        setReadyForCdiQaState(cdiQaCount)
        setReadyForPhysicianState(physicianCount)
      }).catch(() => {
        // Error handled by api.defaultErrorHandler
        // Keep default state (0) on error
      })
    }
    fetchReviewCount()
    return () => {
      isMounted = false
    }
  }, [])

  const counterMessage = () => {
    const msgs = []
    if (readyForPhysicianState > 0) {
      msgs.push(`Ready for Physician: ${readyForPhysicianState}`)
    }
    if (readyForCdiQaState > 0) {
      msgs.push(`Ready for CDI QA: ${readyForCdiQaState}`)
    }
    if (reviewCountState === 0) {
      msgs.push('Ready for Physician: 0; Ready for CDI QA: 0')
    }
    return msgs.join('; ')
  }

  const msg = counterMessage()
  return (
    <span>
      <Responsive
        minWidth={ TABLET_WIDTH.minWidth }
        className="bold"
      >
        <Popup
          content={ msg }
          mouseEnterDelay={ 1000 }
          trigger={
            <span>
              Reviewed: { reviewCountState }
            </span>
          }
        />
      </Responsive>
      <Responsive
        maxWidth={ MOBILE_WIDTH.maxWidth }
        className="bold"
      >
        { reviewCountState }
      </Responsive>
    </span>
  )
}

export default CdiCounter
